<motif-modal-title variant="alt">
  <h3>{{title}}</h3>
  <button motifIconButton aria-label="Close modal" [motif-modal-close]="true">
  <motif-icon [src]="'/assets/icons/navigation/ic_close_24px.svg'"></motif-icon>    </button>
</motif-modal-title>
<motif-modal-content>
  <div class="custom-placeholder">
    <ng-container #customPlaceholder></ng-container>
  </div>
</motif-modal-content>